import { baseUrl } from '../config/clientsConfig'
import axios from "axios";

export const fetchStageCounts = (stageId, selectedTeamId, bodTeamId, userRole,activeTab, userId) => {
    if (!stageId) {
        throw new Error('Stage ID is required');
      }

    let url = `${baseUrl}/analytics?currentStage=${stageId}`;
    //this for overall stage count
    if(userRole === 'Admin' || userRole ==="CMO"){
      url += `&role=${userRole}`;
    }else if ( userRole === 'BOD') {
      url += `&team=${bodTeamId}&role=${userRole}`;
    }else if(userRole === "MD"  ){
      url += `&userId=${userId}&role=${userRole}`;
    }
console.log(selectedTeamId)
    //team wise stage count
    if(userRole === "MD" && selectedTeamId && activeTab === "team"){
      url += `&team=${selectedTeamId}`;
    }else if((userRole === "Admin" || userRole === "CMO") && (selectedTeamId != undefined && activeTab === "team")){
      url += `&team=${selectedTeamId}`;
    }
    return axios.get(url);
  }

  export const fetchCallCounts = (selectedTeamId, bodTeamId, userRole, activeTab) => {
    let url = `${baseUrl}/analytics/calls-count`;
    if(userRole === 'Admin' || userRole ==="CMO"){
      url += `?role=${userRole}`;
    }else if ( userRole === 'BOD') {

      url += `?teamId=${bodTeamId}&role=${userRole}`;
    }if(userRole === "MD"&& selectedTeamId && activeTab === "team"  ){
      url += `?teamId=${selectedTeamId}&role=${userRole}`;
    }else if(userRole === "Admin" || userRole === "CMO" && (selectedTeamId != undefined && activeTab === "team")){
      url += `?teamId=${selectedTeamId}&role=${userRole}`}
    return axios.get(url);
  }

  export const fetchStageCountsData = async (stageId,bodTeamId, userRole) => {
   let url = `${baseUrl}/analytics?currentStage=${stageId}&team=${bodTeamId}&role=${userRole}`;
    if(userRole === 'Admin' || userRole ==="CMO"){
      url += `&role=${userRole}`;
    }else if ( userRole === 'BOD') {
      url += `&team=${bodTeamId}&role=${userRole}`;
    }
    return axios.get(url);
  }